(function(){
  if (window.__cvCartEnhancementsLoaded) return;
  window.__cvCartEnhancementsLoaded = true;
  var timerKey = 'cv-cart-reminder-until';
  function tick() {
    var node = document.querySelector('#cart-drawer [data-cv-countdown]');
    if (!node) return;
    var end = Number(sessionStorage.getItem(timerKey));
    if (!end || !Number.isFinite(end)) { end = Date.now() + 12*60*1000; sessionStorage.setItem(timerKey,String(end)); }
    var remaining = Math.max(0,Math.ceil((end-Date.now())/1000));
    node.textContent = String(Math.floor(remaining/60)).padStart(2,'0') + ':' + String(remaining%60).padStart(2,'0');
    if (!remaining) { var p = node.closest('.cv-cart-reminder'); if (p) p.querySelector('span').textContent = 'Il promemoria è terminato'; }
  }
  setInterval(tick,1000);tick();
  document.addEventListener('click', async function(e){
    var btn = e.target.closest && e.target.closest('#cart-drawer [data-cv-add-id]');
    if (btn) {
      if (btn.disabled) return;
      btn.disabled=true;btn.textContent='Aggiunta...';
      try {
        var prefix=(window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var r=await fetch(prefix+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(btn.dataset.cvAddId),quantity:1})});
        if(!r.ok) throw new Error('Non è stato possibile aggiungere il prodotto.');
        window.location.reload();
      } catch(err) {
        btn.disabled=false;btn.textContent='Aggiungi';
        var error=btn.parentElement.querySelector('.cv-cart-upsell__error');
        if(error){error.textContent=err.message;error.hidden=false;}
      }
      return;
    }
    var arrow=e.target.closest && e.target.closest('#cart-drawer [data-cv-dir]');
    if(arrow){var viewport=arrow.closest('.cv-cart-upsell').querySelector('.cv-cart-upsell__viewport');viewport.scrollBy({left:Number(arrow.dataset.cvDir)*viewport.clientWidth,behavior:'smooth'});}
  });
})();